import { TextField } from "@mui/material";
import { useEffect, useState } from "react";

interface Iprops {
    Value: string;
    Error: string;
    OnCommit: (nextValue: string) => void;
    OnLiveRowUpdate?: (nextValue: string) => void; // Syncs parent row on each keystroke so grid state updates before blur.
    OnValidateWhileTyping?: (nextValue: string) => string;
    Type?: "text" | "number";
}

const TextFiledCellRender = (props: Iprops) => {
    const [value, setValue] = useState(props.Value);
    const [error, setError] = useState(props.Error);

    useEffect(() => {
        setValue(props.Value);
        setError(props.Error);
    }, [props.Value, props.Error]);

    return (
        <div className="w-p-100 h-p-100 d-flex flex-direction">
            <div className="d-flex align-center justify-center h-p-100 w-p-100">
                <TextField
                    fullWidth
                    size="small"
                    sx={{ width: "100%", "& .MuiOutlinedInput-root": { width: "100%" } }}
                    type={props.Type}
                    value={value}
                    error={!!error}
                    onChange={(event) => {
                        const nextValue = event.target.value;
                        setValue(nextValue);
                        if (props.OnValidateWhileTyping) {
                            setError(props.OnValidateWhileTyping(nextValue));
                        }
                        props.OnLiveRowUpdate?.(nextValue);
                    }}
                    onBlur={() => props.OnCommit(value)}
                    InputProps={{ classes: { input: "h6-regular" } }}
                />
            </div>
            <div className="w-p-100 contactinfo-email h6-regular color-primary-danger t-align-right">
                {error || "\u00A0"}
            </div>
        </div>
    );
};

export default TextFiledCellRender;